<section class="flex items-center gap-2.5">
    <!--    <img alt="warning icon" height="21" ngSrc="/assets/icons/warning-triangle-icon.svg" width="20"/>-->
    <div class="flex-1 text-sm font-semibold text-[#FE2C55]">
        {{ data.message }}
    </div>
    <img
        (click)="snackBarRef.dismissWithAction()"
        alt="close icon"
        height="21"
        ngSrc="/assets/icons/warning-x-close-icon.svg"
        width="20" />
</section>
